<div class="gallery-layout" *ngIf="images && images.length > 0; else noImages">
  <div class="gallery-container">
    <button
      class="nav-btn prev"
      (click)="prev()"
      *ngIf="images.length > 1"
      [disabled]="currentIndex === 0"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>

    <div
      class="slide"
      *ngFor="let img of images; let i = index"
      [class.active]="i === currentIndex"
      role="region"
      [attr.aria-label]="'Slide ' + (i + 1)"
    >
      <!-- IMAGE -->
      <img
        *ngIf="img.type !== 'video'"
        [src]="img.mediumUrl || img.url"
        alt="Product Image {{ i + 1 }}"
        loading="lazy"
        (click)="onImageClick()"
        class="clickable-slide"
      />

      <!-- VIDEO -->
      <div
        *ngIf="img.type === 'video'"
        class="video-slide-container"
        (click)="togglePlay($event, galleryVideo)"
      >
        <video
          #galleryVideo
          [src]="img.url"
          [muted]="galleryVideo.paused"
          preload="metadata"
          playsinline
          [controls]="!galleryVideo.paused"
          class="gallery-main-video"
        ></video>
        <div class="play-icon" *ngIf="galleryVideo.paused">▶</div>
      </div>

      <!-- Expand icon hint (Separate from Play) -->
      <span
        class="expand-hint"
        (click)="onImageClick(); $event.stopPropagation()"
        role="button"
        aria-label="Open fullscreen"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="15 3 21 3 21 9" />
          <polyline points="9 21 3 21 3 15" />
          <line x1="21" y1="3" x2="14" y2="10" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      </span>
    </div>

    <button
      class="nav-btn next"
      (click)="next()"
      *ngIf="images.length > 1"
      [disabled]="currentIndex === images.length - 1"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </button>
  </div>

  <!-- Thumbnails for quick navigation -->
  <div class="thumbnails-container" *ngIf="images.length > 1">
    <button class="thumb-nav-btn prev" (click)="scrollThumbs('left')">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>

    <div class="thumbnails" #thumbScroll>
      <div
        class="thumb"
        *ngFor="let img of images; let i = index"
        [class.active]="i === currentIndex"
        [class.video-thumb]="img.type === 'video'"
        (click)="goTo(i)"
      >
        <!-- Standard Image Thumbnail -->
        <img
          *ngIf="img.type !== 'video'"
          [src]="img.thumbUrl || img.url"
          alt="Thumbnail {{ i + 1 }}"
          loading="lazy"
        />

        <!-- Video Thumbnail with Play Icon -->
        <ng-container *ngIf="img.type === 'video'">
          <video
            [src]="img.thumbUrl || img.url"
            muted
            playsinline
            preload="metadata"
            aria-hidden="true"
          ></video>
          <div class="play-icon-small">▶</div>
        </ng-container>
      </div>
    </div>

    <button class="thumb-nav-btn next" (click)="scrollThumbs('right')">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </button>
  </div>
</div>

<ng-template #noImages>
  <div class="gallery-layout">
    <div class="gallery-container empty">
      <div class="slide active">
        <img src="/assets/no-image.png" alt="No image available" />
      </div>
    </div>
  </div>
</ng-template>
